module.exports = __webpack_public_path__ + "img/270deg.e65ec1e6.svg";